import { Col, Divider, Row } from 'antd';
import classNames from 'classnames/bind';
import moment from 'moment';
import styled from 'styled-components';
import { SVGS, IMAGES } from '~/assets/assetsPath';
import styles from './FormCreateSchedule.module.scss';

const cx = classNames.bind(styles);
const BookingContent = styled.div`
    .ant-divider-horizontal {
        margin: 0px;
    }
`;

const CreateScheduleModal = ({ latestBooking }) => {
    let name_services = [];
    if (latestBooking?.booking_details?.length) {
        for (const service of latestBooking?.booking_details) {
            name_services.push(`${service.title} (x${service.count})`);
        }
    }
    return (
        <BookingContent>
            <Row align="middle" justify="center" className={cx('name_page')}>
                {latestBooking?.status && <span>Successful booking</span>}
            </Row>

            <Row align="middle" className={cx('header')}>
                <Col xs={12}>
                    <Row align="middle" justify="start" className={cx('code_title')}>
                        Schedule code:
                    </Row>
                </Col>
                <Col xs={12}>
                    <Row align="middle" justify="end" className={cx('code_title')}>
                        <span className={cx('code_service')}>#{latestBooking?.booking_code}</span>
                    </Row>
                </Col>
            </Row>
            <Divider />
            <Row className={cx('body')} gutter={[0, 32]}>
                <Col span={24} className="gutter-row">
                    <Row>
                        <Col span={16}>
                            <Row className={cx('item')}>
                                <img src={SVGS.IconBodyPeople} alt="" />
                                <span>
                                    {latestBooking?.phone}{' '}
                                    {latestBooking?.fullname ? `(${latestBooking?.fullname})` : ''}
                                </span>
                            </Row>
                            <Row className={cx('item')}>
                                <img src={SVGS.IconTimerBlack} alt="" />
                                <span>
                                    {latestBooking?.time_start
                                        ? moment(new Date(parseInt(latestBooking?.time_start))).format(
                                              'HH:mm, DD/MM/YYYY',
                                          )
                                        : null}
                                </span>
                            </Row>
                            <Row className={cx('item')}>
                                <img src={SVGS.IconPeoples} alt="" />
                                <span>Beauty-ms will use the best staff for you</span>
                            </Row>
                            <Row align="middle">
                                <div className={cx('item')}>
                                    <img src={SVGS.IconBranch} alt="" />
                                    <span>Branch: {latestBooking?.branch?.name || ''}</span>
                                </div>
                            </Row>
                            {name_services?.length > 0 ? (
                                <Row className={cx('item')}>
                                    <img src={SVGS.IconServices} alt="" />
                                    <span>Services: {name_services?.join(' - ')}</span>
                                </Row>
                            ) : null}
                            <Row className={cx('item')}>
                                <img src={SVGS.IconSpecialRequest} alt="" />
                                <span>Special request: {latestBooking?.message || 'No'}</span>
                            </Row>
                        </Col>
                        <Col span={8}>
                            <Row justify="center">
                                <img src={latestBooking?.qr_code_image} alt="" className={cx('qr_img')} />
                            </Row>
                            <Row justify="center" className={cx('bio')}>
                                Schedule code
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Divider />
                <Col span={24} className={`${cx('install_app')} gutter-row`}>
                    <Row align="middle" justify="center" className={cx('title')}>
                        You can view booking schedules through the app
                    </Row>
                    <Row justify="space-around" className={cx('qr_section')}>
                        <img src={IMAGES.QRCodeDownApp} alt="" className={cx('qr_img')} />

                        {/* <a
                            href="https://play.google.com/store/apps/details?id=com.hitek.abeauty"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src={IMAGES.GGPlay} alt="" className={cx('qr_img')} />
                        </a>
                        <a href="https://apps.apple.com/app/vbeauty-spa/id1625638866" target="_blank" rel="noreferrer">
                            <img src={IMAGES.APPStore} alt="" className={cx('qr_img')} />
                        </a> */}
                    </Row>
                    <Row justify="center" className={cx('bio')}>
                        Scan the code to install the application!
                    </Row>
                </Col>
            </Row>
        </BookingContent>
    );
};

export default CreateScheduleModal;
